export enum ActionsEnum {
    Categories="categories",
    GoogleUtm="googleUtm",
    Duyurular="duyurular",
    Bilgilendirme="bilgilendirme",
    Dealer="dealer",
    DealerMinimalize="dealerMinimalize",
    Kurulum="kurulum",
    Seo="seo",
    Comments="comments",
    Config="config",
    Pages="pages",
    Blog="blog",
    Users="users",
    UsersSanitized="usersSanitized",
    CategoryShow="categoryShow",
    Slider="slider",
    Banner="banner",
    Fonts="fonts",
    GlobalProductSettings = "globalProductSettings",
    ProductGroup = "productGroup",
    Campaigns = "campaign",
    Sss = "sss",
    Kk = "kk",
    Product = "product",
    Sozlesme = "sozlesme",
    ProductVariant = "productVariant",
    Cargo = "cargo",
    PaymentTypes = "paymentTypes",
    SanalPos = "sanalPos",
    Sablon = "sablon",
    Coupon = "coupon",
    Discount = "discount",
    Orders  = "orders",
    CreateOrder = "createOrder",
    BarcodeList = "barcodeList",
    Logs = "logs",
    OrderList = "orderList",
    Jobs = "jobs",
    Nots = "nots",
    UrumDetay="urunDetay",
    IcwHesaplar="icwHesaplar",
    IcwIcraDairesiMahkeme="icwIcraDairesiMahkeme",
    IcwNoterler="icwNoterler",
    IcwHarclar="icwHarclar",
    IcwMasraflar="icwMasraflar",
    IcwFaizler="icwFaizler",
    IcwIhtiyatiHaciz="icwIhtiyatiHaciz",
    IcwBanka="icwBanka",
    IcwYargiBirimi="icwYargiBirimi",
    IcwLogs="icwLogs",
    IcwGeceKosusu="icwGeceKosusu",
    Customers = "customers",
    Survey = "survey",
    ArbUyusmazlikTurleri = "arbUyusmazlikTurleri",
    ArbDavaTurleri = "arbDavaTurleri",
    TenantPool = "tenantPool",
}
